"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.slice.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PageItem = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _DownOutlined = _interopRequireDefault(require("@ant-design/icons/DownOutlined"));

var _UpOutlined = _interopRequireDefault(require("@ant-design/icons/UpOutlined"));

var _LeftOutlined = _interopRequireDefault(require("@ant-design/icons/LeftOutlined"));

var _RightOutlined = _interopRequireDefault(require("@ant-design/icons/RightOutlined"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _DecoratorsRoot = require("../../layout/DecoratorsRoot");

var _useMobilePages2 = require("../hooks/useMobilePages");

var _useButtonSettings5 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

var _Partials = require("./Partials");

var _Icon = _interopRequireDefault(require("../../menu/Icon"));

var _utils = require("../../nav/utils");

var _Sheet = _interopRequireDefault(require("./Sheet"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

require("../styles/drawer.less");

var styles = {
  "button": "meepshop-meep-ui__mobileLayout-drawer__button",
  "buttonText": "meepshop-meep-ui__mobileLayout-drawer__buttonText",
  "subButton": "meepshop-meep-ui__mobileLayout-drawer__subButton",
  "buttonGroupSubmenu": "meepshop-meep-ui__mobileLayout-drawer__buttonGroupSubmenu",
  "rootButton": "meepshop-meep-ui__mobileLayout-drawer__rootButton",
  "bottom": "meepshop-meep-ui__mobileLayout-drawer__bottom",
  "bottomItem": "meepshop-meep-ui__mobileLayout-drawer__bottomItem",
  "divider": "meepshop-meep-ui__mobileLayout-drawer__divider",
  "bottomItemMenuButton": "meepshop-meep-ui__mobileLayout-drawer__bottomItemMenuButton",
  "subPage": "meepshop-meep-ui__mobileLayout-drawer__subPage",
  "subPageHeader": "meepshop-meep-ui__mobileLayout-drawer__subPageHeader",
  "subPageLeft": "meepshop-meep-ui__mobileLayout-drawer__subPageLeft",
  "subPageRight": "meepshop-meep-ui__mobileLayout-drawer__subPageRight",
  "sheetContent": "meepshop-meep-ui__mobileLayout-drawer__sheetContent",
  "arrow": "meepshop-meep-ui__mobileLayout-drawer__arrow"
};

var ButtonGroup = function ButtonGroup(_ref) {
  var page = _ref.page,
      level = _ref.level,
      useIcon = _ref.useIcon,
      onGroupClick = _ref.onGroupClick;

  var _useButtonSettings = (0, _useButtonSettings5["default"])(page),
      title = _useButtonSettings.title,
      url = _useButtonSettings.url,
      target = _useButtonSettings.target,
      isActive = _useButtonSettings.isActive,
      isVisible = _useButtonSettings.isVisible,
      isChildrenVisible = _useButtonSettings.isChildrenVisible;

  var _useContext = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      isLogin = _useContext.isLogin;
  /* 頁面上下架狀態若下架，則不顯示 menu item */


  if (!isVisible) return null;
  var iconProps = (0, _utils.getIconProps)(page, {
    isLogin: isLogin
  });

  var handleGroupClick = function handleGroupClick(e) {
    e.preventDefault();
    e.stopPropagation();
    /* 所有子頁面上下架狀態若下架，則不觸發 */

    if (isChildrenVisible) {
      onGroupClick(page);
    }

    return false;
  }; // 如果在相同頁面了，保持點擊展開子選單的行為


  var shouldKeepOriginalBehavior = isActive && target !== '_blank';
  var linkClassName = "".concat(styles.button, " ").concat(level > 0 ? styles.subButton : styles.rootButton);
  var linkStyles = {
    gridTemplateColumns: useIcon ? '20px 1fr 50px' : '1fr 50px'
  };

  if (url && !shouldKeepOriginalBehavior) {
    return /*#__PURE__*/_react["default"].createElement(_link["default"], {
      href: url,
      target: target,
      passHref: true
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: linkClassName,
      style: linkStyles,
      type: "button",
      href: url,
      target: target
    }, useIcon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
      imagePosition: "LEFT",
      iconSize: 20
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: styles.buttonText
    }, title), isChildrenVisible && /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.arrow,
      onClick: handleGroupClick
    }, /*#__PURE__*/_react["default"].createElement(_RightOutlined["default"], null))));
  }

  return /*#__PURE__*/_react["default"].createElement("button", {
    className: linkClassName,
    style: linkStyles,
    type: "button",
    onClick: handleGroupClick
  }, useIcon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
    imagePosition: "LEFT",
    iconSize: 20
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.buttonText
  }, title), isChildrenVisible && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.arrow
  }, /*#__PURE__*/_react["default"].createElement(_RightOutlined["default"], null)));
};

var PageItem = function PageItem(_ref2) {
  var page = _ref2.page,
      useIcon = _ref2.useIcon,
      onSubPageOpen = _ref2.onSubPageOpen;

  var _useButtonSettings2 = (0, _useButtonSettings5["default"])(page),
      hasGroup = _useButtonSettings2.hasGroup;

  if (hasGroup) {
    return /*#__PURE__*/_react["default"].createElement(ButtonGroup, {
      styles: styles,
      page: page,
      useIcon: useIcon,
      onGroupClick: onSubPageOpen
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_Partials.Button, {
    styles: styles,
    page: page,
    useIcon: useIcon
  });
};

exports.PageItem = PageItem;

var BottomItem = function BottomItem(_ref3) {
  var icon = _ref3.icon,
      page = _ref3.page,
      background = _ref3.background,
      color = _ref3.color;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useButtonSettings3 = (0, _useButtonSettings5["default"])(page),
      title = _useButtonSettings3.title;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    style: styles,
    type: "button",
    className: styles.bottomItem,
    onClick: function onClick() {
      return setOpen(true);
    }
  }, icon, title, open ? /*#__PURE__*/_react["default"].createElement(_UpOutlined["default"], {
    style: {
      fontSize: 12
    }
  }) : /*#__PURE__*/_react["default"].createElement(_DownOutlined["default"], {
    style: {
      fontSize: 12
    }
  })), /*#__PURE__*/_react["default"].createElement(_Sheet["default"], {
    disableDrag: true,
    open: open,
    background: background,
    color: color,
    height: page.pages.length * 48,
    onClose: function onClose() {
      return setOpen(false);
    }
  }, page.pages.map(function (child) {
    return /*#__PURE__*/_react["default"].createElement(_Partials.Button, {
      styles: styles,
      className: styles.bottomItemMenuButton,
      key: child.id,
      page: child,
      useIcon: false,
      onClick: function onClick() {
        return setOpen(false);
      }
    });
  })));
};

var SubPage = function SubPage(_ref4) {
  var style = _ref4.style,
      useIcon = _ref4.useIcon,
      page = _ref4.page,
      background = _ref4.background,
      color = _ref4.color,
      showHeader = _ref4.showHeader,
      _onSubPageOpen = _ref4.onSubPageOpen,
      onSubPageClose = _ref4.onSubPageClose;

  var _useButtonSettings4 = (0, _useButtonSettings5["default"])(page),
      title = _useButtonSettings4.title;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.subPage,
    style: _objectSpread({
      background: background,
      color: color,
      fill: color
    }, style)
  }, showHeader && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.subPageHeader,
    onClick: onSubPageClose
  }, /*#__PURE__*/_react["default"].createElement(_LeftOutlined["default"], {
    width: 12,
    height: 12,
    style: {
      fontSize: 12
    }
  }), /*#__PURE__*/_react["default"].createElement("span", null, title)), page.pages.map(function (child) {
    return /*#__PURE__*/_react["default"].createElement(PageItem, {
      styles: styles,
      key: child.id,
      page: child,
      useIcon: useIcon,
      onSubPageOpen: function onSubPageOpen() {
        return _onSubPageOpen(child);
      }
    });
  }));
};

var Drawer = function Drawer(_ref5) {
  var color = _ref5.color,
      background = _ref5.background,
      open = _ref5.open,
      pagesProps = _ref5.pages,
      useIcon = _ref5.useIcon,
      onClose = _ref5.onClose;

  var _useMobilePages = (0, _useMobilePages2.useMobilePages)(pagesProps),
      currencyPage = _useMobilePages.currencyPage,
      localePage = _useMobilePages.localePage,
      otherPages = _useMobilePages.otherPages,
      bottomPagesCount = _useMobilePages.bottomPagesCount;

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      activePages = _useState4[0],
      setActivePages = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      subSheetOpenIndex = _useState6[0],
      setSubSheetOpenIndex = _useState6[1];

  var handleSubPageOpen = function handleSubPageOpen(subPage) {
    setActivePages(function (st) {
      return [].concat((0, _toConsumableArray2["default"])(st.slice(0, subSheetOpenIndex)), [subPage]);
    });
    setSubSheetOpenIndex(function (st) {
      return st + 1;
    });
  };

  var handleSubPageClose = function handleSubPageClose() {
    setSubSheetOpenIndex(function (st) {
      return st - 1;
    });
  };

  (0, _react.useEffect)(function () {
    if (!open) {
      setSubSheetOpenIndex(0);
    }
  }, [open]);
  return /*#__PURE__*/_react["default"].createElement(_Sheet["default"], {
    zIndex: 800,
    open: open,
    background: background,
    color: color,
    onClose: onClose,
    contentClassname: styles.sheetContent,
    hideClose: true,
    renderFooter: !!bottomPagesCount && /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.bottom
    }, !!localePage && /*#__PURE__*/_react["default"].createElement(BottomItem, {
      page: localePage,
      background: background,
      color: color
    }), bottomPagesCount === 2 && /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.divider
    }), !!currencyPage && /*#__PURE__*/_react["default"].createElement(BottomItem, {
      page: currencyPage,
      background: background,
      color: color
    }))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      height: '100%',
      width: '100svw',
      transition: 'transform 0.2s ease-in-out',
      transform: "translateX(-".concat(100 * subSheetOpenIndex, "%)")
    }
  }, /*#__PURE__*/_react["default"].createElement(SubPage, {
    page: {
      pages: otherPages
    },
    background: background,
    color: color,
    useIcon: useIcon,
    onSubPageOpen: handleSubPageOpen,
    onSubPageClose: onClose
  }), activePages.map(function (page) {
    return /*#__PURE__*/_react["default"].createElement(SubPage, {
      key: page.id,
      page: page,
      background: background,
      showHeader: true,
      color: color,
      onSubPageOpen: handleSubPageOpen,
      onSubPageClose: handleSubPageClose
    });
  })));
};

var _default = Drawer;
exports["default"] = _default;